import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Navbar, Modal, ModalHeader, ModalBody } from "reactstrap";
import { vendorProfileSelector } from "slices/vendor/profileSlice";
import { cdn } from 'constants/common';

let userSlice;
function Header(props) {
  const [color] = React.useState("transparent");
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [videoModalOpen, setVideoModalOpen] = React.useState(false);

  const refDropdown = React.useRef(null);

  useEffect(() => {
    userSlice = require("../../slices/userSlice");
  }, []);

  const { vendorProfile } = useSelector(vendorProfileSelector);
  const displayUser = vendorProfile;
  
  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (refDropdown.current && !refDropdown.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close dropdown on route change
  useEffect(() => {
    setDropdownOpen(false);
  }, [location]);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleLogout = () => {
    dispatch(userSlice.logout());
    navigate("/login", { replace: true });
  };

  return (
    <>
      <Navbar
        expand="lg"
        className={
          location.pathname.indexOf("full-screen-maps") !== -1
            ? "navbar-absolute border-0 fixed-top"
            : "navbar-absolute border-0 fixed-top " +
              (color === "transparent" ? "navbar-transparent " : "")
        }
      >
        <div className="header">
          <button className="toggle_sidebar" onClick={props.toggleSidebar}>
            <img src="/images/ham.png" alt="" />
          </button>

          <div className="row_user_side d-flex align-items-center">
            <div className="d-flex align-items-center" style={{ marginRight: '16px' }}>
                <style>
                  {`
                    @keyframes pointRightToGuide {
                      0% { transform: translateX(0); }
                      50% { transform: translateX(6px); }
                      100% { transform: translateX(0); }
                    }
                  `}
                </style>
                <span style={{ 
                  display: 'inline-block', 
                  animation: 'pointRightToGuide 1s infinite', 
                  marginRight: '8px',
                  color: '#3176a0',
                  fontWeight: '600',
                  fontSize: '14px',
                  whiteSpace: 'nowrap'
                }}>
                  Watch Tutorial →
                </span>
                <button 
                  onClick={() => setVideoModalOpen(true)}
                  style={{ 
                      background: 'linear-gradient(45deg, #3176a0, #1b5b80)', 
                      border: 'none', 
                      borderRadius: '50%', 
                      width: '35px', 
                      height: '35px', 
                      color: 'white', 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      cursor: 'pointer',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                  }}
                  title="Watch Tutorial"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                      <line x1="12" y1="17" x2="12.01" y2="17"></line>
                  </svg>
                </button>
            </div>

            <div ref={refDropdown} className="d-flex align-items-center gap-2 position-relative">
              <button className="user_image" onClick={toggleDropdown}>
                {/* <img src="/images/default-person.png" alt="" /> */}
                 {displayUser?.image ? (
                    <img src={cdn + displayUser.image} alt={displayUser.name} />
                  ) : (
                    <img src="/images/default-person.png" alt="Default profile" />
                  )}
                <span></span>
              </button>

              <button
                className={`drop_icon ${dropdownOpen ? "active" : ""}`}
                onClick={toggleDropdown}
              >
                <img src="/images/drop.png" alt="" />
              </button>

              <div
                className={`drop_more_selector ${
                  dropdownOpen ? "active" : ""
                }`}
              >
                <ul>
                  <li>
                    <Link to="/vendor/profile">Profile</Link>
                  </li>
                  <li>
                    <Link to="/vendor/change-password">Change Password</Link>
                  </li>
                  <li>
                    <Link href="#!" onClick={(e) => { e.preventDefault(); setVideoModalOpen(true); toggleDropdown(); }}>Help</Link>
                  </li>
                  <li>
                    <a
                      href=""
                      onClick={handleLogout}
                      className="red_clr"
                    >
                      Log Out
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Navbar>

      <Modal isOpen={videoModalOpen} toggle={() => setVideoModalOpen(!videoModalOpen)} size="lg" centered>
        <ModalHeader toggle={() => setVideoModalOpen(!videoModalOpen)}>Vendor Portal Tutorial</ModalHeader>
        <ModalBody className="p-0 text-center" style={{ backgroundColor: '#000' }}>
          <div className="ratio ratio-16x9">
            <iframe 
              width="100%" 
              height="450" 
              src="https://www.youtube.com/embed/7sqrfopQBzc?si=C2UCfuWMKoUawyK-&rel=0&modestbranding=1&showinfo=0" 
              title="YouTube video player" 
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
              referrerPolicy="strict-origin-when-cross-origin" 
              allowFullScreen
            ></iframe>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default Header;
